module.exports = __webpack_public_path__ + "img/15.0ed47f0e.jpg";